// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__LbLmY","container":"Footer_container__PKVMV","footerContent":"Footer_footerContent__+v1Ud","socials":"Footer_socials__QP-Um"};